import React from 'react';
import GenericModal from '@components/common/modals/GenericModal';
import Button from '@components/common/Button';

interface ConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  confirmLabel?: string;
  confirmVariant?: 'primary' | 'danger' | 'secondary';
  isProcessing?: boolean;
  dataTestId?: string;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmLabel = 'Confirm',
  confirmVariant = 'primary',
  isProcessing = false,
  dataTestId = 'confirmation-modal'
}) => {
  return (
    <GenericModal isOpen={isOpen} onClose={onClose} title={title} size="sm" dataTestId={dataTestId}>
      <div>
        <p style={{ marginBottom: '20px' }}>{message}</p>
        <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
          <Button variant="secondary" onClick={onClose} disabled={isProcessing}>
            Cancel
          </Button>
          <Button variant={confirmVariant} onClick={onConfirm} loading={isProcessing}>
            {confirmLabel}
          </Button>
        </div>
      </div>
    </GenericModal>
  );
};

export default ConfirmationModal;
